import { z } from 'zod/mini'

export const tokenToLsSchema = z.object({
  token: z.string(),
  subscriptionId: z.optional(z.coerce.number()),
  account: z.object({
    id: z.number(),
    email: z.string(),
    username: z.nullable(z.string()),
    planId: z.optional(z.nullable(z.number())),
    coins: z.optional(z.nullable(z.number())),
    languages: z.nullable(z.record(z.string(), z.array(z.string()))),
    lastSelectedLanguages: z.optional(z.tuple([z.string(), z.string()])),
  }),
})
